/*
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
 * software and associated documentation files (the "Software"), to deal in the Software
 * without restriction, including without limitation the rights to use, copy, modify,
 * merge, publish, distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
 * INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, of, timer } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import {ServiceHelperService}from './service-helper.service'
import { PaymentService } from './payment/payment.service';
@Injectable({ providedIn: 'root' })
export class CognitoGuard implements CanActivate {
    actualSub : any 
    startTime= new Date();
    actualplan: any
    endDate: Date
    countdownTime : any;
    durationInSeconds:any
     days:any ;
    hours  :any;
    minutes:any ;
    seconds: any ; 
    diffInMilliseconds:any;
    constructor( private payservice:PaymentService,private oidcSecurityService: OidcSecurityService, private router: Router , private service : ServiceHelperService ) {}

    // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    //   function getResolvedUrl(route: ActivatedRouteSnapshot): string {
    //     return route.pathFromRoot
    //         .map(v => v.url.map(segment => segment.toString()).join(''))
    //         .join('/');
    //   }

    //   return this.oidcSecurityService.isAuthenticated$.pipe(
    //       map((isAuthorized: boolean) => {

    //           console.log('AuthorizationGuard, canActivate isAuthorized: ' + isAuthorized);
    //           if (!isAuthorized) {
    //               this.router.navigate(['/unauthorized']);
    //               return false;
    //           }

    //           return true;
    //       })
    //   );
    // }

    a = false 
   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if(localStorage.getItem('Role')==="Client") {
    this.verifSub();}
      return this.service.VerifToken().pipe(
        map(data => {
          console.log(data, 'dataaaaaaaaaaaaa');
          if (data['message'] === 'No token provided!') {
            this.router.navigate(['/unauthorized']);
            return false;
          } else if (data['message'] === 'autreuser!') {
            this.router.navigate(['/unauthorized']);
            return false;
          } else {
            return true;
          }
        })
      );
    }


  


       /* 
   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        function getResolvedUrl(route: ActivatedRouteSnapshot): string {
          return route.pathFromRoot
              .map(v => v.url.map(segment => segment.toString()).join(''))
              .join('/');
        }

 this.verifSub()

        this.service.VerifToken().subscribe(data =>{
            console.log (data, "dataaaaaaaaaaaaa ")
        
            if (data['message'] =='No token provided!') {
                this.router.navigate(['/unauthorized']);
                this.a = false 
                return false;
           
            } 
            else
            if (data['message'] == 'autreuser!'){
                this.router.navigate(['/unauthorized'])
            } 
            else {
            this.a = true  
            return true;
            }
        
        })
        return this.a;
    //     return this.oidcSecurityService.isAuthenticated$.pipe(
    //         map((isAuthorized: boolean) => {

    //             console.log('AuthorizationGuard, canActivate isAuthorized: ' + isAuthorized);
    //             if (!isAuthorized) {
    //                 this.router.navigate(['/unauthorized']);
    //                 return false;
    //             }

    //             return true;
    //         })
    //     );
    //   }
    }*/
    verifSub() {
      this.payservice.getActualSubByEmail(localStorage.getItem('email')).subscribe(
        datas => {
          this.actualSub = datas;
    
          this.actualplan = this.actualSub['Type'];
          this.endDate = new Date(this.actualSub['dateFin']);
          const diffInMilliseconds = this.endDate.getTime() - this.startTime.getTime();
          this.durationInSeconds = Math.floor(diffInMilliseconds / 1000);
          this.days = Math.floor(this.durationInSeconds / 86400);
          this.hours = Math.floor((this.durationInSeconds % 86400) / 3600);
          this.minutes = Math.floor((this.durationInSeconds % 3600) / 60);
          this.seconds = Math.floor(this.durationInSeconds % 60);
    
          timer(0, 1000)
            .pipe(takeWhile(() => this.durationInSeconds > 0))
            .subscribe(() => {
              this.durationInSeconds--;
              this.days = Math.floor(this.durationInSeconds / (24 * 60 * 60));
              this.hours = Math.floor((this.durationInSeconds % (24 * 60 * 60)) / (60 * 60));
              this.minutes = Math.floor((this.durationInSeconds % (60 * 60)) / 60);
              this.seconds = Math.floor(this.durationInSeconds % 60);
            });
    
          timer(diffInMilliseconds)
            .pipe(takeWhile(() => this.durationInSeconds <= 0))
            .subscribe(() => {
              this.router.navigate(['/']);
              this.payservice.endSub(localStorage.getItem('email')).subscribe();
            });
        },
        error => {
          console.log(error);
          if (error.status == 401) {
            this.router.navigate(['/']);
          }
        }
      );
    }
  }


  @Injectable({
    providedIn: 'root'
  })
  export class AdminAuthGuard implements CanActivate {

    constructor(private router: Router) { }
  
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const userRole = localStorage.getItem('Role'); 
        if (userRole === 'admin') {
          return true;
          
        } else {
          this.router.navigate(['/unauthorized']);
          return false;
        }
      }
    }
  